import { render, staticRenderFns } from "./PendingExternalProductsTable.vue?vue&type=template&id=5be146b4&scoped=true"
import script from "./PendingExternalProductsTable.vue?vue&type=script&lang=js"
export * from "./PendingExternalProductsTable.vue?vue&type=script&lang=js"
import style0 from "./PendingExternalProductsTable.vue?vue&type=style&index=0&id=5be146b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be146b4",
  null
  
)

export default component.exports